import React from 'react';

import { ReadAloudContent } from '../readAloud/readAloudContent';
import { staticStringSource } from '../../libs/speech/clipSource';
import { defaultLanguageOptions, ENGLISH, languageToLocale } from '../../utils/languageList';
import { TrackAnalyticsEvent } from '../../../Diagnostic/actions/analytics';
import { Events } from '../../../Diagnostic/modules/analytics';

interface LanguageSelectionPageProps {
  questionCount?: number,
  dispatch: Function,
  setLanguage: (language: string) => void,
  previewMode: boolean,
  beginActivity?: () => void,
  languages: string[],
  handlePageLoaded?: () => void,
  isDiagnosticActivity?: boolean;
}

export const LanguageSelectionPage = ({
  questionCount,
  dispatch,
  setLanguage,
  previewMode,
  beginActivity,
  languages,
  handlePageLoaded,
  isDiagnosticActivity,
}: LanguageSelectionPageProps) => {
  function handleClickLanguage (e) {
    if (handlePageLoaded) {
      handlePageLoaded()
    }
    const language = e.currentTarget.value;
    if (isDiagnosticActivity && language !== ENGLISH) {
      dispatch(TrackAnalyticsEvent(Events.DIAGNOSTIC_LANGUAGE_SELECTED, { language }));
    }
    setLanguage(language);
    if (previewMode && beginActivity) { beginActivity() }
  }
  return (
    <div className="language-page">
      <div className="language-page-content">
        <div className="introductory-text">
          <ReadAloudContent label="Read this page aloud" source={questionCount ? staticStringSource('translations.languageSelectionWithCount', questionCount) : null}>
            <h1>Hello there!</h1>
            {questionCount && <p className="body-text">{`You are about to start a ${questionCount} question Placement Activity.`}</p>}
            <p className="body-text">First, let&#39;s set up your language preference. All the directions are in English by default.</p>
          </ReadAloudContent>
          <p className="body-text">Show directions only in:</p>
        </div>
        <div className="language-selection-main">
          <div className="language-button-container english">
            <button aria-label={ENGLISH} className="language-button focus-on-light" onClick={handleClickLanguage} type="button" value="english">
              <img alt="flag" className="language-button-img" src={defaultLanguageOptions[ENGLISH].flag} />
              <p className="language-label">English</p>
            </button>
          </div>
          <div className="divider-container">
            <div className="divider" />
            <p className="divider-label">or</p>
            <div className="divider" />
          </div>
          <p className="bilingual-label">Show directions in English <span>and</span>:</p>
          <div className="language-button-container">
            {languages.map(language => {
              const permittedLanguages = JSON.parse(window.postbuildEnv.PERMITTED_LANGUAGES)
              const isPermittedLanguage = permittedLanguages.includes(language) || isDiagnosticActivity
              if (language !== ENGLISH && isPermittedLanguage) {
                return (
                  <button aria-label={language} className="language-button focus-on-light" key={`${language}-button`} onClick={handleClickLanguage} type="button" value={language}>
                    <img alt="flag" className="language-button-img" src={defaultLanguageOptions[language].flag} />
                    <p className="language-label" lang={languageToLocale[language]}>{defaultLanguageOptions[language].label}</p>
                  </button>
                );
              }
            })}
          </div>
        </div>
      </div>
    </div>
  );
}

export default LanguageSelectionPage;
